import React from 'react';
import { Button, DatePicker, Form, Space } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { RECURRING_DUE_DATE_PRESETS } from '../constants';

interface RecurringDueDateFieldsProps {
  fieldName?: string;
  label?: string;
}

const RecurringDueDateFields: React.FC<RecurringDueDateFieldsProps> = ({
  fieldName = 'nextDueDate',
  label = 'Next due date',
}) => {
  const form = Form.useFormInstance();

  const applyPreset = (days: number) => {
    const nextDate = dayjs().add(days, 'day').startOf('day');
    form.setFieldValue(fieldName, nextDate);
  };

  return (
    <>
      <Form.Item label="Schedule next occurrence">
        <Space wrap>
          {RECURRING_DUE_DATE_PRESETS.map((preset) => (
            <Button key={preset.days} onClick={() => applyPreset(preset.days)}>
              {preset.label}
            </Button>
          ))}
        </Space>
      </Form.Item>
      <Form.Item
        name={fieldName}
        label={label}
        rules={[{ required: true, message: 'Next due date is required' }]}
      >
        <DatePicker
          style={{ width: '100%' }}
          disabledDate={(current) => current !== null && current.isBefore(dayjs().startOf('day'))}
          getPopupContainer={(trigger) => trigger.parentElement!}
        />
      </Form.Item>
    </>
  );
};

export type { Dayjs };

export default RecurringDueDateFields;
